// extracted by mini-css-extract-plugin
export default {"item":"app-react-azure-container-instances-CreateView-PortsMappingField-module__item","errors":"app-react-azure-container-instances-CreateView-PortsMappingField-module__errors"};